import Loader from './loader';

export default class IngredientCalculator {
    constructor($block) {
        this.$block = $block;
        this.$wrapper = this.$block.querySelector('[data-ingredient-calculator]');
        this.$field = this.$wrapper.querySelector('[data-ingredient-calculator-control]');
        this.$loaderLabel = this.$wrapper.querySelector('[data-loader-label]');
        this.$ingredients = this.$wrapper.querySelector('[data-ingredients]');

        this.objectId = this.$wrapper.dataset.objectId;
        this.objectTypeId = this.$wrapper.dataset.objectTypeId;

        this.calculateIngredients = this.calculateIngredients.bind(this);
        this.fetchResult = this.fetchResult.bind(this);
        this.getUrl = this.getUrl.bind(this);
        this.render = this.render.bind(this);
        this.renderGroup = this.renderGroup.bind(this);
        this.loading = this.loading.bind(this);
        this.renderIngredient = this.renderIngredient.bind(this);

        this.$field.addEventListener('change', this.calculateIngredients);
    }

    async calculateIngredients(e) {
        this.loading(true);

        const result = await this.fetchResult();
        this.loading(false);
        this.render(result);
    }

    getUrl() {
        const url = (new URL(placeholders.router.request));
        url.pathname += '/block/'+ this.$block.dataset.blockId + '/ajax/calculate-ingredients/'
                + this.objectId;

        url.searchParams.set('amount', this.$field.value);
        return url.toString();
    }

    async fetchResult() {
        const url = this.getUrl();
        try {
            const request = await fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            this.loading(false);
        }
    }

    render(result) {
        result.ingredients.forEach(group => this.renderGroup(group));
    }

    renderGroup(group) {
        group.items.forEach(ingredient => this.renderIngredient(ingredient));
    }

    renderIngredient(ingredient) {
        if(this.$wrapper.querySelector('[data-ingredient-id="' + ingredient.id + '"] [data-amount]')) {
            this.$wrapper.querySelector('[data-ingredient-id="' + ingredient.id + '"] [data-unit]').textContent = ingredient.unit;
            this.$wrapper.querySelector('[data-ingredient-id="' + ingredient.id + '"] [data-amount]').textContent = ingredient.amount;
        }
    }

    loading(loading) {
        clearTimeout(this.timeout);
        if(loading) {
            this.timeout = setTimeout(() => {
                this.$loaderLabel.classList.add('form__number-loader--loading');
                this.$ingredients.classList.add('recipe-content__ingredient-list--loading');
            }, 200)
        } else {
            this.$loaderLabel.classList.remove('form__number-loader--loading');
            this.$ingredients.classList.remove('recipe-content__ingredient-list--loading');
        }
    }
}